import React from "react";

import { Box, Typography } from "@mui/material";
import EmptyCardChartImage from "assets/images/EmptyCardChart.png";

interface EmptyCardChartProps {
  title?: string;
}

export const EmptyCardChart: React.FC<EmptyCardChartProps> = ({ title }) => {
  return (
    <Box display="flex" flexDirection="column" width="100%" height="100%" padding="16px">
      {title && (
        <Typography fontWeight={500} color="#071F35" mb={1} pr="48px" variant="h6">
          {title}
        </Typography>
      )}
      <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" flex={1}>
        <Box component="img" src={EmptyCardChartImage} alt="No data" width={153} height={93} />
        <Typography color="#92A7BC" variant="body2">
          No data
        </Typography>
      </Box>
    </Box>
  );
};
